import ValidateResponse from "./ValidateResponse";

export default interface FormFieldValidationResponse extends ValidateResponse {
    field: string[];
    value: string[];
    to: string[];
    from: string[];
    fromAndTo: string[];
}

export const defaultValue = (): FormFieldValidationResponse => {
    return {
        value: [],
        operator: [],
        from: [],
        field: [],
        to: [],
        fromAndTo: [],
        isValid: true,
        default: []
    };
}